import { type FC } from 'react';

// Shared Dropdown Component to eliminate duplication
export const DropdownWrapper: FC<{
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  isGenerating: boolean;
  buttonWidth?: string;
  displayContent: React.ReactNode;
  ariaLabel: string;
  isMobile?: boolean;
  isTablet?: boolean;
  children: React.ReactNode;
}> = ({ isOpen, setIsOpen, isGenerating, buttonWidth = '138px', displayContent, ariaLabel, isMobile = false, isTablet = false, children }) => {
  return (
    <div className="flex justify-center">
      <div className={`flex justify-start ${isMobile || isTablet ? "w-[80%]" : ""}`}>
        <div className="relative" style={{ marginLeft: isMobile || isTablet ? '1.5rem' : '0' }}>
          {/* Dropdown Button */}
          <button
            onClick={() => !isGenerating && setIsOpen(!isOpen)}
            disabled={isGenerating}
            className="font-medium transition-all duration-300 focus:outline-none bg-white cursor-pointer flex items-center justify-center"
            style={{
              width: buttonWidth,
              height: '42px',
              paddingTop: '9px',
              paddingRight: '27px',
              paddingBottom: '9px',
              paddingLeft: '27px',
              gap: '10px',
              borderRadius: '100px',
              border: "2px solid transparent",
              background: "linear-gradient(#FFFFFF, #FFFFFF) padding-box, linear-gradient(to right, #F39A81, #959BEA) border-box",
              fontFamily: 'Maven Pro',
            }}
          >
            {displayContent}
          </button>

          {/* Click outside to close */}
          {isOpen && (
            <button 
              type="button"
              className="fixed inset-0 z-40 bg-transparent border-0 p-0 cursor-default" 
              onClick={() => setIsOpen(false)}
              onKeyDown={(e) => {
                if (e.key === 'Escape' || e.key === 'Enter' || e.key === ' ') {
                  setIsOpen(false);
                }
              }}
              aria-label={ariaLabel}
              style={{ background: 'transparent' }}
            />
          )}

          {/* Dropdown Menu */}
          {isOpen && children}
        </div>
      </div>
    </div>
  );
};
